// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Modal from "../../resources/overlays/Modal.res.js";
import * as React from "react";
import * as Future from "rescript-future/src/Future.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as OrderMutations from "./OrderMutations.res.js";
import * as JsxRuntime from "react/jsx-runtime";

function OrderArchiveModal(props) {
  let commitCallbackUrl = props.commitCallbackUrl;
  let navigate = Navigation.useNavigate();
  let archiveOrder = OrderMutations.useArchive(props.orderId, undefined);
  return JsxRuntime.jsx(Modal.make, {
    children: JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsx(TextStyle.make, {
        children: I18n.t("Once the order is archived, it will only be visible in the order list by applying the \"Archive\" filter."),
        variation: "normal"
      }),
      spaceX: "xlarge",
      spaceY: "xxlarge"
    }),
    opened: props.opened,
    title: I18n.t("Confirm the archiving of this order"),
    abortButtonText: I18n.t("Cancel"),
    commitButtonText: I18n.t("Confirm"),
    commitButtonCallback: () => Future.get(archiveOrder(), result => {
      if (result.TAG === "Ok" && commitCallbackUrl !== undefined) {
        return navigate(undefined, commitCallbackUrl);
      }
    }),
    onRequestClose: props.onRequestClose
  });
}

let make = React.memo(OrderArchiveModal, (oldProps, newProps) => {
  if (oldProps.orderId === newProps.orderId) {
    return oldProps.opened === newProps.opened;
  } else {
    return false;
  }
});

export {
  make,
}
/* make Not a pure module */
